/* Copyright (c) 2017 Backpack Health LLC */

/* global window */

import * as _ from 'lodash';
import PropTypes from 'prop-types';
import Croppie from 'croppie';
import { FormattedMessage } from 'react-intl';
import PhotoModel from '../../../../models/PhotoModel';

import '../../../../node_modules/croppie/croppie.css';
import './ProfilePhotoCrop.scss';

import { Body } from '../../../components/Text';
import { Grid, Cell } from '../../../components/Grid';
import ProfileService from '../../../../apiServices/ProfileService';
import UI_CONSTANTS, { getStaticAppMenuWidth } from '../../../../constants/uiConstants';

const maxWidth = UI_CONSTANTS.applicationMaxWidth;

class ProfilePhotoCrop extends React.Component {
  constructor(props) {
    super(props);

    this.choosePhoto = this.choosePhoto.bind(this);
    this.cancelPhoto = this.cancelPhoto.bind(this);
    this.updateAvatar = this.updateAvatar.bind(this);

    this.state = {
      viewErrorMessage: '',
      uploadRequest: null,
      uploadProgress: 0,
      isUploading: false,
    };
  }

  componentDidMount() {
    const dataUrl = this.props.photo.data.dataUrl;
    this.croppie = new Croppie(this.elCroppie, {
      viewport: { width: 300, height: 300, type: 'circle' },
      boundary: {
        width: Math.min(window.innerWidth - getStaticAppMenuWidth(), maxWidth),
        height: window.innerHeight - 140,
      },
      customClass: 'cmp-avatarcrop',
      showZoomer: false,
      url: dataUrl,
      update: () => {
        // limit max zoom to viewport size (300x300)
        this.croppie.elements.zoomer.max = 1;
      },
    });
  }

  updateAvatar(photoBlob) {
    this.setState({ isUploading: true });
    const uploadRequest = ProfileService.updateAvatar(
      this.props.profileId,
      photoBlob,
      (progressEvent) => {
        const percentComplete = _.get(progressEvent, 'percent', 0);
        if (percentComplete > this.state.uploadProgress) {
          this.setState({ uploadProgress: Math.min(percentComplete, 100) });
        }
      },
      (apiError) => {
        if (apiError) {
          // TODO: Show error message
          // console.log(apiError.messageKey());
        } else {
          this.setState({ isUploading: false });
          this.props.actions.onUploadedPhoto();
        }
      }
    );

    this.setState({ uploadRequest });
  }

  choosePhoto() {
    this.croppie.result('blob').then((blob) => {
      PhotoModel.createFromRawFile(
        blob,
        false,
        (newPhoto) => {
          if (newPhoto.isDimensionTooLarge()) {
            // Reduce image size when cropped image larger than 1200x1200
            newPhoto.resizeImage(1200, this.updateAvatar);
          } if (!newPhoto.isSquareImage()) {
            // crop the image to be square
            newPhoto.cropToSquare(this.updateAvatar);
          } else {
            this.updateAvatar(newPhoto.data.fileData);
          }
        }
      );
    });
  }

  cancelPhoto() {
    this.setState({ isUploading: false });
    if (this.state.uploadRequest) {
      this.state.uploadRequest.abort();
      this.setState({ uploadRequest: null });
    }
    this.props.actions.onCancelPhoto();
  }

  clearViewErrors() {
    this.setState({ viewErrorMessage: '' });
  }

  render() {
    return (
      <div style={{ height: '100%', width: '100%', backgroundColor: 'black' }}>
        <div className="header-photo">
          <Body>
            <span style={{ color: 'white' }}>
              <FormattedMessage id="profilePhoto.title.text" />
            </span>
          </Body>
        </div>
        <div ref={(r) => { this.elCroppie = r; }} />
        <div className="footer-photo-menu">
          <Grid alignItems="center" justifyContent="space-between">
            <Cell width="50%">
              <div onClick={this.cancelPhoto} style={{ cursor: 'pointer' }}>
                <Body>
                  <span style={{ color: 'white' }}>
                    <FormattedMessage id="photoMenu.cancel.button.label" />
                  </span>
                </Body>
              </div>
            </Cell>
            <Cell>
              {this.state.isUploading ? (
                <Body>
                <span style={{ color: 'white' }}>
                  {`${Math.ceil(this.state.uploadProgress)}%`}
                  </span>
                </Body>
              ) : (
                <div onClick={this.choosePhoto} style={{ cursor: 'pointer' }}>
                  <Body>
                  <span style={{ color: 'white' }}>
                    <FormattedMessage id="photoMenu.choosePhoto.button.label" />
                  </span>
                  </Body>
                </div>
              )}
            </Cell>
          </Grid>
        </div>
      </div>
    );
  }
}

ProfilePhotoCrop.propTypes = {
  photo: PropTypes.instanceOf(PhotoModel).isRequired,
  profileId: PropTypes.number,
  actions: PropTypes.shape({
    onUploadedPhoto: PropTypes.func.isRequired,
    onCancelPhoto: PropTypes.func.isRequired,
  }),
};

export default ProfilePhotoCrop;
